import React from 'react';
import { useModalDismiss } from '../../../hooks/useModalDismiss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheckCircle, faExclamationCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const AlertModal = ({ 
  show, 
  title, 
  message, 
  type = 'info', // 'success', 'error', 'warning', 'info'
  onClose 
}) => {
  const dismiss = useModalDismiss(onClose, { enabled: show });

  if (!show) return null;

  const typeConfig = {
    success: {
      icon: faCheckCircle,
      iconColor: 'text-green-500',
      borderColor: 'border-green-200',
      titleColor: 'text-green-900',
      bgColor: 'bg-green-50'
    },
    error: {
      icon: faExclamationCircle,
      iconColor: 'text-red-500',
      borderColor: 'border-red-200',
      titleColor: 'text-red-900',
      bgColor: 'bg-red-50'
    },
    warning: {
      icon: faExclamationCircle,
      iconColor: 'text-yellow-500',
      borderColor: 'border-yellow-200',
      titleColor: 'text-yellow-900',
      bgColor: 'bg-yellow-50'
    },
    info: {
      icon: faInfoCircle,
      iconColor: 'text-blue-500',
      borderColor: 'border-blue-200',
      titleColor: 'text-blue-900',
      bgColor: 'bg-blue-50'
    }
  };

  const config = typeConfig[type];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" {...dismiss}>
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4" onClick={(e) => e.stopPropagation()}>
        <div className={`px-6 py-4 border-b ${config.borderColor} ${config.bgColor}`}>
          <div className="flex items-center justify-between">
            <h3 className={`text-lg font-semibold flex items-center gap-2 ${config.titleColor}`}>
              <FontAwesomeIcon icon={config.icon} className={config.iconColor} />
              {title}
            </h3>
            <button 
              className="text-gray-400 hover:text-gray-600 transition-colors"
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
        </div>
        <div className="px-6 py-4">
          <p className="text-gray-700">{message}</p>
        </div>
        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end rounded-b-lg">
          <button
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;

